import { createContext } from 'react';

import { OrderStatusReason } from 'enums';
import {
  Bank,
  Currency,
  PaymentType,
  User,
  TradeMethod,
  Meta,
  CurrencyExchange,
  SciDomain,
  P2PProvider,
  AssetCurrencyExchange,
  SidebarHeaderConfig,
  Cascade,
} from 'types';

export type AccountNumberQrSupportedCombination = {
  currencyCode: string;
  paymentType: string;
};

export type UserContextProps = {
  user: User;
  fiatCurrencies: Currency[];
  assetCurrencies: Currency[];
  banks: Bank[];
  banksRaw: Bank[];
  sidebarHeaderConfig: SidebarHeaderConfig;
  paymentTypes: PaymentType[];
  tradeMethods: TradeMethod[];
  orderStatusReasons: OrderStatusReason[];
  allTradeMethods: TradeMethod[];
  currencyExchanges: CurrencyExchange[];
  meta: Meta[];
  sciDomains: SciDomain[];
  p2pProviders: P2PProvider[];
  assetCurrencyExchange: AssetCurrencyExchange[];
  accountNumberQrSupportedCombinations: AccountNumberQrSupportedCombination[];
  cascades: Cascade[];
};

export const UserContext = createContext<UserContextProps>(
  {} as UserContextProps,
);
